import type { AuthSlice } from '../bs/auth'

/**
 * English for the signed-out screens.
 *
 * The audience here is narrow and worth picturing: somebody standing at the
 * shared terminal by the door who does not read the local language. Short
 * sentences, no jargon, and "card" rather than "badge" — the physical thing in
 * their hand is a printed card.
 */
export const auth: AuthSlice = {
  'login.tagline': 'Control and improvement — reports and 5S from the floor.',
  'login.employeeCode': 'Employee code',
  'login.employeeCode.placeholder': 'e.g. 1042',
  'login.password': 'Password',

  'login.firstTime': 'Signing in for the first time?',
  'login.firstTime.switch': 'Use an activation code',
  'login.firstTime.back': 'Got your own password? Sign in with it.',
  'login.activationCode': 'Activation code',
  'login.activationCode.hint':
    'Eight characters, from the slip your supervisor gave you. You set your own password straight after signing in.',
  'login.forgotPassword': 'Forgotten your password?',
  'login.remember': 'Remember me on this device',
  'login.remember.hint': 'Turn this off on a shared computer in the plant.',
  'login.submit': 'Sign in',
  'login.failed': 'Sign-in failed.',
  'login.or': 'or',
  'login.scanBadge': 'Sign in by scanning your card',
  'login.offlineNotice':
    'Works without a signal. Your report is saved on the phone and sent by itself once the connection is back.',

  'login.badge.working': 'Signing in…',
  'login.badge.hint': 'Hold the card up to the camera. The code is read for you.',
  'login.badge.back': 'Back to signing in with a password',
  'login.badge.failed': 'That card was not recognised.',

  'login.twoFactor.accepted': 'Password accepted. One code left to go.',
  'login.twoFactor.appCode': 'Code from the app',
  'login.twoFactor.appCode.hint': 'The six-digit code from the app on your phone.',
  'login.twoFactor.recoveryCode': 'Backup code',
  'login.twoFactor.recoveryCode.hint':
    'One of the codes you saved when you switched protection on. It works once.',
  'login.twoFactor.confirm': 'Confirm',
  'login.twoFactor.failed': 'That did not confirm.',
  'login.twoFactor.lostPhone': 'I have lost my phone',
  'login.twoFactor.haveAppCode': 'I have the code from the app',
  'login.twoFactor.back': 'Back',
  'login.reader.hint': 'If a reader is connected, just scan the card — nothing to click.',
  'login.reader.working': 'Card read, signing you in…',
  'login.reader.codeRead': 'Code read from the card. Enter the password.',
}
